import { ReactElement } from 'react'
import styled from 'styled-components'
import { Theme } from 'theme/theme'
import UploadProductsCards from 'modules/product/UploadProducts/UploadProductsCard'
import UploadClientsCards from 'modules/client/UploadClients/UploadClientsCards'

export default function ArtisanUpload(): ReactElement {
  return (
    <Wrapper>
      <UploadClientsCards />
      <UploadProductsCards />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 32px;
  gap: 40px;
`

export const SectionGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const SectionTitle = styled.h2`
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: ${Theme.font.family};
  font-size: 18px;
  font-weight: 600;
  color: ${Theme.colors.blackArtizen};
  margin: 0;
  padding-bottom: 8px;
  border-bottom: 2px solid ${Theme.colors.greenArtizen};
`

export const CardsRow = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
`

export const UploadCard = styled.div`
  flex: 1;
  min-width: 260px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px;
  background: #ffffff;
  border: 1px solid #e0e4ef;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(8, 27, 60, 0.06);
`

export const CardLabel = styled.span`
  font-family: ${Theme.font.family};
  font-size: 15px;
  font-weight: 600;
  color: ${Theme.colors.blackArtizen};
`

export const CardDescription = styled.span`
  font-family: ${Theme.font.family};
  font-size: 13px;
  color: ${Theme.colors.greyDark};
`

export const ErrorMessage = styled.p`
  font-family: ${Theme.font.family};
  font-size: 13px;
  color: red;
  margin: 0;
`

export const FileInputLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: ${Theme.colors.greyLighter};
  color: ${Theme.colors.blueArtizen};
  border: 1px solid ${Theme.colors.blueArtizen};
  border-radius: 6px;
  font-family: ${Theme.font.family};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
  width: fit-content;

  &:hover {
    background: #e8ecf8;
  }
`
export const ExportButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: ${Theme.colors.greyLighter};
  color: ${Theme.colors.blueArtizen};
  border: 1px solid ${Theme.colors.blueArtizen};
  border-radius: 6px;
  font-family: ${Theme.font.family};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
  width: fit-content;

  &:hover {
    background: #e8ecf8;
  }
`

export const HiddenInput = styled.input`
  display: none;
`
